import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    erroredRadio: {
      color: theme.palette.error.main,
    },
  });
});
